/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'ai-summary-label': 'Zusammenfassen',
  'copy-content-link-label': 'Link kopieren',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text':
    'Beginnen Sie mit der Eingabe, um nach einem Stichwort zu suchen.',
  'dynamic-cards-search-page.app-filter-sidebar.all': 'Alle',
  'dynamic-cards-search-page.app-filter-sidebar.group': 'Suche nach Produkt filtern',
  'dynamic-cards-search-page.atlas.for': 'für',
  'dynamic-cards-search-page.avatar': 'Profilbild',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': 'Kalender',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': 'Meeting beitreten',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': 'Meeting-Link',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': 'Meeting beitreten',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': 'Vergangene Ereignisse',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': 'Wiederkehrende Ereignisse',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': 'Wiederkehrend',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': 'Bevorstehende Ereignisse',
  'dynamic-cards-search-page.compass.owner-name': 'Besitzer: {ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': 'Stufe {tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': 'Inhalte suchen',
  'dynamic-cards-search-page.confluence.filter.content.selected': 'Ausgewählt',
  'dynamic-cards-search-page.confluence.filter.content.unselected': 'Vorgeschlagen',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': 'Ausgewählt',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': 'Vorgeschlagen',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': 'Personen suchen',
  'dynamic-cards-search-page.confluence.filter.label.selected': 'Ausgewählt',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': 'Stichwörter suchen',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': 'Bereiche suchen',
  'dynamic-cards-search-page.connect_third_party_product_description':
    'Verbinden Sie Ihr Konto, um die fehlenden Ergebnisse sehen zu können.',
  'dynamic-cards-search-page.connect_third_party_product_title': 'Ihr Admin hat {product} hinzugefügt.',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '{product} ist jetzt verfügbar!',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end': 'Das Startdatum muss vor dem Enddatum liegen.',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today':
    'Das Startdatum darf nicht in der Zukunft liegen.',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today':
    'Das Enddatum darf nicht in der Zukunft liegen.',
  'dynamic-cards-search-page.date.filter.last.month': 'Letzte 30 Tage',
  'dynamic-cards-search-page.date.filter.last.week': 'Letzte 7 Tage',
  'dynamic-cards-search-page.date.filter.last.year': 'Letztes Jahr',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.dropdown_generate_answer': 'Antwort generieren',
  'dynamic-cards-search-page.dropdown_recent_icon_label': 'Zuletzt verwendet',
  'dynamic-cards-search-page.error_primary': 'Probleme bei der Suche',
  'dynamic-cards-search-page.error_secondary':
    'Das war vielleicht nur eine kurze Störung. Am besten <btn>versuchen Sie es erneut</btn>.',
  'dynamic-cards-search-page.externalPeopleLabel': 'Externe Personen #{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': 'Filter löschen',
  'dynamic-cards-search-page.filter.last.updated.anytime': 'Beliebig',
  'dynamic-cards-search-page.filter.last.updated.past30Days': 'Letzte 30 Tage',
  'dynamic-cards-search-page.filter.last.updated.past7Days': 'Letzte 7 Tage',
  'dynamic-cards-search-page.filter.last.updated.pastYear': 'Letztes Jahr',
  'dynamic-cards-search-page.filter.last.updated.today': 'Heute',
  'dynamic-cards-search-page.filter.last.updated.yesterday': 'Gestern',
  'dynamic-cards-search-page.filter.type.answer': 'Antworten',
  'dynamic-cards-search-page.filter.type.attachment': 'Anhänge',
  'dynamic-cards-search-page.filter.type.blogpost': 'Blogposts',
  'dynamic-cards-search-page.filter.type.branch': 'Branches',
  'dynamic-cards-search-page.filter.type.calendar': 'Kalender',
  'dynamic-cards-search-page.filter.type.card': 'Karte',
  'dynamic-cards-search-page.filter.type.comment': 'Kommentare',
  'dynamic-cards-search-page.filter.type.commit': 'Commits',
  'dynamic-cards-search-page.filter.type.component': 'Komponenten',
  'dynamic-cards-search-page.filter.type.conversation': 'Konversationen',
  'dynamic-cards-search-page.filter.type.database': 'Datenbanken',
  'dynamic-cards-search-page.filter.type.design': 'Designs',
  'dynamic-cards-search-page.filter.type.documents': 'Dokumente',
  'dynamic-cards-search-page.filter.type.embed': 'Intelligente Links',
  'dynamic-cards-search-page.filter.type.issue': 'Vorgänge',
  'dynamic-cards-search-page.filter.type.message': 'Nachrichten',
  'dynamic-cards-search-page.filter.type.page': 'Seiten',
  'dynamic-cards-search-page.filter.type.placeholder': 'Typ finden',
  'dynamic-cards-search-page.filter.type.presentation': 'Präsentationen',
  'dynamic-cards-search-page.filter.type.pull-request': 'Pull-Anfragen',
  'dynamic-cards-search-page.filter.type.question': 'Fragen',
  'dynamic-cards-search-page.filter.type.repository': 'Repositorys',
  'dynamic-cards-search-page.filter.type.space': 'Bereiche',
  'dynamic-cards-search-page.filter.type.space-calendar': 'Bereichskalender',
  'dynamic-cards-search-page.filter.type.spreadsheet': 'Kalkulationstabellen',
  'dynamic-cards-search-page.filter.type.video': 'Videos',
  'dynamic-cards-search-page.filter.type.web-page': 'Webseiten',
  'dynamic-cards-search-page.filter.type.whiteboard': 'Whiteboards',
  'dynamic-cards-search-page.filters.dropdown.clear-all': 'Alle löschen',
  'dynamic-cards-search-page.filters.dropdown.title': 'Filter',
  'dynamic-cards-search-page.filters.names.content': 'Inhalt unter',
  'dynamic-cards-search-page.filters.names.contributor': 'Beitragender',
  'dynamic-cards-search-page.filters.names.labels': 'Label',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': 'Titel-Übereinstimmung',
  'dynamic-cards-search-page.github-branch-result.label': 'Branch',
  'dynamic-cards-search-page.github-commit-result.label': 'Commit',
  'dynamic-cards-search-page.github-pull-request-result.label': 'Pull-Anfrage',
  'dynamic-cards-search-page.input_placeholder': 'Führen Sie eine Suche durch oder stellen Sie eine beliebige Frage',
  'dynamic-cards-search-page.input_placeholder_search_only': 'Beliebigen Inhalt suchen',
  'dynamic-cards-search-page.jira.filter.project.placeholder': 'Projekte suchen',
  'dynamic-cards-search-page.landing_primary': 'Mit Filtern für dynamische Karten beginnen',
  'dynamic-cards-search-page.legacy-third-party-result.google-docs-label': 'Dokumente',
  'dynamic-cards-search-page.legacy-third-party-result.google-presentation-label': 'Folien',
  'dynamic-cards-search-page.legacy-third-party-result.google-sheets-label': 'Tabellen',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': 'Es wurden keine Ergebnisse gefunden, die Ihrer Suche entsprechen.',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    'Sie haben Filter angewendet. Versuchen Sie es mit einer Suche ohne diese Filter.',
  'dynamic-cards-search-page.nouns.goal': 'Ziel',
  'dynamic-cards-search-page.nouns.goals': 'Ziele',
  'dynamic-cards-search-page.nouns.tag': 'Tag',
  'dynamic-cards-search-page.nouns.tags': 'Tags',
  'dynamic-cards-search-page.number_of_results':
    'Es werden {numberOfResults,number} von {totalCount,number} Ergebnissen angezeigt.',
  'dynamic-cards-search-page.oauth-banner.authorization-fail':
    'Die Autorisierung für {product} konnte nicht durchgeführt werden.',
  'dynamic-cards-search-page.oauth-banner.authorization-success': 'Die Autorisierung für {product} war erfolgreich.',
  'dynamic-cards-search-page.oauth-message-connect': 'Verbinden',
  'dynamic-cards-search-page.products.custom-website': 'Webseite',
  'dynamic-cards-search-page.results-sort.createdDate.selected': 'Sortierreihenfolge: Erstellungsdatum (neuestes)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': 'Erstellungsdatum (neuestes)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': 'Letzte Aktualisierung (neueste)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected':
    'Sortierreihenfolge: Letzte Aktualisierung (neueste)',
  'dynamic-cards-search-page.results-sort.sort-options.label': 'Listensortierung ändern',
  'dynamic-cards-search-page.rovo-onboarding-dismiss': 'Schließen',
  'dynamic-cards-search-page.rovo-onboarding-next': 'Weiter',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description':
    'Filtern Sie nach Produkt, um relevantere Suchergebnisse zu erhalten.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading': 'In allen Arbeitsbereichen des Unternehmens suchen',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    'Je nachdem, nach welchem Produkt Sie filtern, ändern sich diese Optionen, damit Ihnen bestimmte Ergebnisse angezeigt werden.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': 'Genau das finden, wonach Sie suchen',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': 'Anhang',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': 'Angehängt am {formattedDate}',
  'dynamic-cards-search-page.search-result.attachments.audio-label': 'Audio',
  'dynamic-cards-search-page.search-result.attachments.image-label': 'Bild',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': 'Aktualisiert: {formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': 'Privater Kanal',
  'dynamic-cards-search-page.search-result.remove-recent-search': 'Symbol: Letzten Suchvorgang entfernen',
  'dynamic-cards-search-page.search-result.repository-label': 'Repository',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {Gruppenkommunikation mit externen Benutzern} =2 {{name1} und {name2}} =3 {{name1}, {name2} und {name3}} =4 {{name1}, {name2}, {name3} und {overflowContributorCount} weiterer} one {{name1}} other {{name1}, {name2}, {name3} und {overflowContributorCount} weitere}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': 'unbekannter-Channel',
  'dynamic-cards-search-page.search_result_type_answer': 'Antwort',
  'dynamic-cards-search-page.search_result_type_comment': 'Kommentieren',
  'dynamic-cards-search-page.search_result_type_component': 'Komponente',
  'dynamic-cards-search-page.search_result_type_embed': 'Intelligenter Link',
  'dynamic-cards-search-page.search_result_type_folder': 'Ordner',
  'dynamic-cards-search-page.search_result_type_presentation': 'Präsentation',
  'dynamic-cards-search-page.search_result_type_pull_request': 'Pull-Anfrage',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'SharePoint-Dokument',
  'dynamic-cards-search-page.search_result_type_space_calendar': 'Bereichskalender',
  'dynamic-cards-search-page.search_result_type_spreadsheet': 'Kalkulationstabelle',
  'dynamic-cards-search-page.search_result_type_unrecognised': 'Unbekannt',
  'dynamic-cards-search-page.search_result_type_work_item': 'Vorgang',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    'Ihr Administrator hat <strong>{product}</strong> hinzugefügt!{br} Verbinden Sie Ihr Konto, um fehlende Ergebnisse zu sehen, einschließlich Dokumente, auf die nur Sie Zugriff haben.',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>{product} ist jetzt verfügbar!</strong>{br} Verbinden Sie Ihr Konto, um fehlende Ergebnisse zu sehen, einschließlich Dokumente, auf die nur Sie Zugriff haben.',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': 'Autorisieren',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail':
    'Die Autorisierung für {product} ist fehlgeschlagen.',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success':
    'Die Autorisierung für {product} war erfolgreich.',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': 'Nach allen Apps filtern',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': 'Nach "Mehr Apps" filtern',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': 'Archiviert',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': 'Mit Risiken',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': 'Abgebrochen',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': 'Abgeschlossen',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': 'Vom Kurs abgekommen',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': 'Auf Kurs',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': 'Angehalten',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': 'Ausstehend',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, one {{chapterCount,number} Kapitel in diesem Video} other {{chapterCount,number} Kapitel in diesem Video}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': 'Videosymbol',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': 'Video-Miniaturansicht',
  'dynamic-cards-search-page.work-item-assignee.assigned': 'ist zugewiesen',
  'dynamic-cards-search-page.work-item-creator.created': 'hat erstellt',
  'dynamic-cards-search-page.work-item-status.for': 'für',
  'dynamic-cards-search-page.work-item-task.label': 'Task',
  'dynamic-cards-search-page.work-item-ticket.label': 'Ticket',
  'dynamic-cards-search-page.work-item.label': 'Vorgang',
  'initialsAvatar.label': 'Profilbild mit Initialen',
  'personAvatar.label': 'Profilbild mit Person',
  'search-page.results.private-result-label': 'Privat',
  'search-page.results.private-result-tooltip': 'Nur für Sie sichtbar',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, one {{memberCount,number} Mitglied} other {{memberCount,number} Mitglieder}}',
  'search-page.results.product-results.third-party.channel-type-label': 'Channel',
  'search-page.results.product-results.third-party.conversation-search-result.label': 'Kanal',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, one {{count,number} Mitglied} other {{count,number} Mitglieder}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    'Zuletzt aktiv am {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': 'unbekannter-Channel',
  'search-page.results.product-results.third-party.external-people-label': 'Externe Personen',
  'search-page.results.product-results.third-party.external-person-label': 'Externe Person',
  'search-page.results.product-results.third-party.last-active': 'Zuletzt aktiv am {relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': 'Nachricht',
  'search-page.results.product-results.third-party.no-contributors-label': 'Externe Personen in #{channelName}',
  'search-page.results.product-results.third-party.private-conversation-text': '{users} in einer privaten Unterhaltung',
  'search-page.results.product-results.third-party.thread-type-label': 'Thread',
  'search-page.results.product-results.third-party.title-and-channel-name': '{title} in #{channelName}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, one {{title} und {remainingContributorsCount} weiterer} other {{title} und {remainingContributorsCount} weitere}}',
  'search-page.results.restricted-result-label': 'Eingeschränkt',
  'search-page.results.restricted-result-tooltip': 'Nur für bestimmte Personen sichtbar',
  'search-page.show-more-breadcrumbs-button-label': 'Weitere Breadcrumbs anzeigen',
  'search-page.verified-icon-label': 'Verifiziert',
  'search-page.verified-icon-tooltip-message': 'Diese Seite wurde von einem Besitzer oder Administrator verifiziert.',
  'search-result.result.count':
    '{count, plural, one {{count} Ergebnis wird angezeigt} other {{count} Ergebnisse werden angezeigt}}',
  'search-result.user-mention.external-person': 'Externe Person',
};
